(function() {
  'use strict';

  var form = document.getElementById('kbc-product-form');
  if (!form) return;

  var variantSelect = document.getElementById('kbc-variant-select');
  var quantityInput = document.getElementById('kbc-product-quantity');
  var priceEl = document.getElementById('kbc-product-price');
  var noteEl = document.getElementById('kbc-product-price-note');
  var statusEl = document.getElementById('kbc-product-status');
  var addButton = document.getElementById('kbc-add-to-basket');
  var checkoutButton = document.getElementById('kbc-checkout-now');
  var variantsScript = document.getElementById('kbc-product-variants');
  if (!variantSelect || !priceEl || !variantsScript) return;

  var variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent || '[]');
  } catch (error) {
    variants = [];
  }

  function getSelectedVariant() {
    var id = String(variantSelect.value || '');
    for (var i = 0; i < variants.length; i += 1) {
      if (String(variants[i].id) === id) return variants[i];
    }
    return null;
  }

  function setStatus(message, tone) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    statusEl.classList.remove('is-error', 'is-success');
    if (tone === 'error') statusEl.classList.add('is-error');
    if (tone === 'success') statusEl.classList.add('is-success');
  }

  function updateVariantDisplay() {
    var variant = getSelectedVariant();
    if (!variant) return;

    priceEl.textContent = variant.price || '';
    if (noteEl) {
      if (variant.available) {
        noteEl.textContent = 'Choose your preferred option below, then add it to your basket for secure Shopify checkout.';
      } else {
        noteEl.textContent = 'This option is currently unavailable. Please try another variant or get in touch.';
      }
    }

    if (addButton) addButton.disabled = !variant.available;
    if (checkoutButton) checkoutButton.disabled = !variant.available;
    setStatus('', '');
  }

  async function addToCart(redirectToCheckout) {
    var variant = getSelectedVariant();
    if (!variant || !variant.available) {
      setStatus('This option is currently unavailable.', 'error');
      return;
    }

    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value ? quantityInput.value : '1', 10) || 1);
    var payload = {
      items: [
        {
          id: variant.id,
          quantity: quantity
        }
      ]
    };

    var activeButton = redirectToCheckout ? checkoutButton : addButton;
    var originalText = activeButton ? activeButton.textContent : '';
    if (activeButton) {
      activeButton.disabled = true;
      activeButton.textContent = redirectToCheckout ? 'Preparing checkout...' : 'Adding...';
    }

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error('Could not add this keepsake to the basket.');
      }

      if (redirectToCheckout) {
        window.location.href = '/checkout';
        return;
      }

      setStatus('Added to basket. You can continue browsing or head to checkout whenever you are ready.', 'success');
    } catch (error) {
      setStatus(error.message || 'Could not update the basket right now.', 'error');
    } finally {
      if (activeButton) {
        activeButton.disabled = false;
        activeButton.textContent = originalText;
      }
      updateVariantDisplay();
    }
  }

  variantSelect.addEventListener('change', updateVariantDisplay);

  if (addButton) {
    addButton.addEventListener('click', function(event) {
      event.preventDefault();
      addToCart(false);
    });
  }

  if (checkoutButton) {
    checkoutButton.addEventListener('click', function(event) {
      event.preventDefault();
      addToCart(true);
    });
  }

  form.addEventListener('submit', function(event) {
    event.preventDefault();
    addToCart(false);
  });

  updateVariantDisplay();
})();
